import { useBlockProps } from '@wordpress/block-editor';

export default function save( { attributes } ) {
	return (		
		<div { ...useBlockProps.save() }>
			<div>{attributes.title}</div>
			<div>{attributes.start_hour}:{attributes.start_minute}</div>
			<div>{attributes.end_hour}:{attributes.end_minute}</div>
			<div>{attributes.locale}</div>
			<div>{attributes.participants}</div>
			<div>{attributes.update_message}</div>
		</div>
	);
}